export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
// Which of the logged-in email's own org accounts is active this session —
// only meaningful when the same email is a PortalUsers account in more than
// one org (see ClientPermissions.availableOrgs). Unrelated to
// useSelectedOrgStore, which is a Platform Admin's cross-tenant data filter,
// not an identity/role switch.
export const ACTIVE_ORG_ID = "activeOrgId";
export const RECORDS_EXCEEDS_ALERT_MSG =
  "A maximum of 1000 records can be downloaded at once. Please apply filters to reduce the number of results.";

// platform.organizations.id for org_code='DEFAULT'. Single source of truth
// for org_id on the frontend until a second org exists.
export const DEFAULT_ORG_ID = 1;
